import { takeLatest, put, call } from 'redux-saga/effects';
import get from 'lodash/get';
import { showLoader } from '../globalReducer';
import { fetchPatientProfile, fetchPatientProfileSuccess, fetchPatientFolder, fetchPatientFolderSuccess, fetchFolderDocsByPatientId, fetchFolderDocsByPatientIdSuccess } from './patient-slice';
import { chrApi, phrApi } from '../../api/api';
import { apiErrorHandler } from '../Utils/apiErrorHandler';

function getPatientProfileApi(chrPatientId) {
  return chrApi('get', `patient/${chrPatientId}`, null);
}
function* getPatientProfile(action) {
  try {
    yield put(showLoader(true));
    const { data } = yield call(getPatientProfileApi, action.payload);
    yield put(showLoader(false));
    yield put(fetchPatientProfileSuccess({ data }));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

export function* getPatientProfileSaga() {
  yield takeLatest(fetchPatientProfile.type, getPatientProfile);
}

function* _fetchPatientFolder(action) {
  try {
    const { patientId } = action.payload;
    yield put(showLoader(true));
    const { data } = yield call(() => chrApi('get', 'secure_share/reports_menu', null, null));
    yield put(showLoader(false));
    yield put(fetchPatientFolderSuccess({ data }));
    const firstApiKey = get(data, '[0].subMenuItems[0].apiKey', undefined);
    const firstTitle = get(data, '[0].subMenuItems[0].title', undefined);
    if (firstApiKey) {
      yield put(fetchFolderDocsByPatientId({ patientId, apiKey: firstApiKey, title: firstTitle }));
    }
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}
function* _fetchFolderDocsByPatientId(action) {
  try {
    yield put(showLoader(true));
    const { patientId, apiKey, title } = action.payload;
    const { data } = yield call(() => chrApi('get', `secure_share/all_patient_docs/patient/${patientId}/api_key/${apiKey}`, null, null));
    yield put(fetchFolderDocsByPatientIdSuccess({ data, apiKey, title }));
    yield put(showLoader(false));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

export function* fetchPatientFolderSaga() {
  yield takeLatest(fetchPatientFolder.type, _fetchPatientFolder);
}
export function* fetchFolderDocsByPatientIdSaga() {
  yield takeLatest(fetchFolderDocsByPatientId.type, _fetchFolderDocsByPatientId);
}
